export const useSchemaForLD = (mode, data) => {
  switch (mode) {
    case 'organization':
      return {
        '@context': 'http://schema.org',
        '@type': 'Organization',
        '@id': '#organization',
        name: 'STOX Energy Socks',
        url: data.websiteUrl,
        address: {
          streetAddress: 'Olympisch Stadion 37',
          addressLocality: 'Amsterdam',
          addressRegion: 'North Holland',
          postalCode: '1076 DE',
          addressCountry: 'Netherlands',
        },
        logo: `https:${data.logo.file.url}`,
        sameAs: [
          'https://www.instagram.com/stoxenergy/?hl=en',
          'https://twitter.com/stoxenergy?lang=en',
          'https://www.facebook.com/stoxenergy/',
        ],
        brand: {
          '@type': 'Brand',
          name: 'STOX',
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: data.trustScore,
          bestRating: 5,
          reviewCount: data.totalNumberOfReviews,
        },
        contactPoint: {
          email: 'support@stoxenergy.com',
          telephone: '+31 20 260 0129',
        },
      }
    case 'article':
      return {
        '@context': 'https://schema.org',
        '@type': 'Article',
        image: data.image?.file?.url && `https:${data.image.file.url}`,
        url: data.url,
        headline: data.headline,
        name: data.name,
        datePublished: data.datePublished,
        dateModified: data.dateModified,
        description: data.description,
        inLanguage: data.inLanguage,
        isFamilyFriendly: true,
        contentLocation: {
          '@type': 'Place',
          name: 'Amsterdam',
        },
        author: {
          '@type': 'Organization',
          name: 'STOX Energy Socks',
          url: 'https://www.stoxenergy.com',
        },
        publisher: {
          '@type': 'Organization',
          name: 'STOX Energy Socks',
          url: 'https://www.stoxenergy.com',
          logo: {
            '@type': 'ImageObject',
            url: data.image?.file?.url ? `https:${data.image.file.url}` : '',
          },
        },
        keywords: data.keywords,
        genre: ['Sports', 'Medical', 'Health', 'Fashion'],
        articleSection: 'Uncategorized posts',
        articleBody: data.articleBody,
      }
    // ----------------------------------------
    case 'breadcrumb':
      return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: data.position,
            name: data.name,
            item: `https://www.stoxenergy.com${data.item}`,
          },
        ],
      }
    //-----------------------------------------

    case 'product':
      const todayIs30NOV =
        new Date().toLocaleDateString() ===
        new Date('2021-11-30').toLocaleDateString()
      const priceValidUntil = todayIs30NOV
        ? new Date().getFullYear() + 1
        : new Date('2021-11-30').toLocaleDateString() // shows 2021-11-29T23:00:00.000Z

      return {
        '@context': 'http://schema.org',
        '@type': 'Product',
        '@id': data.id,
        name: data.name,
        description: data.description,
        image: data.image,
        sku: data.sku,
        color: data.color.map((c) => c.color.title),
        material: data.material,
        brand: {
          '@type': 'Brand',
          name: 'STOX',
        },
        offers: {
          // https://schema.org/Offer
          '@type': 'Offer',
          url: data.offerUrl,
          priceCurrency: data.priceCurrency,
          price: data.price,
          itemCondition: 'http://schema.org/NewCondition',
          availability: 'https://schema.org/InStock',
          seller: {
            '@type': 'Organization',
            name: 'STOX Energy Socks',
          },
          // This is made up to test if this improves SEO
          priceValidUntil,
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: data.aggregateRating.ratingValue,
          reviewCount: data.aggregateRating.reviewCount,
        },
        review: {
          '@type': 'Review',
          reviewRating: {
            '@type': 'Rating',
            ratingValue: data.review.reviewRating.ratingValue,
          },
          author: {
            '@type': 'Person',
            name: data.review.author.name,
          },
          reviewBody: data.reviewBody,
        },
        // isRelatedTo: data.isRelatedTo.map(relatedProduct => relatedProduct),
      }

    case 'faq':
      if (data.firstSectionAccordion) {
        return {
          '@context': 'http://schema.org',
          '@type': 'FAQPage',
          mainEntity: [
            data.firstSectionAccordion?.map((q) => {
              return {
                '@type': 'Question',
                name: q.title,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: q?.content?.raw?.content?.[0]?.content?.[0]?.value,
                },
              }
            }),
            data.secondSectionAccordion?.map((q) => {
              return {
                '@type': 'Question',
                name: q.title,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: q?.content?.raw?.content?.[0]?.content?.[0]?.value,
                },
              }
            }),
            data.thirdSectionAccordion?.map((q) => {
              return {
                '@type': 'Question',
                name: q.title,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: q?.content?.raw?.content?.[0]?.content?.[0]?.value,
                },
              }
            }),
            data.fourthSectionAccordion?.map((q) => {
              return {
                '@type': 'Question',
                name: q.title,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: q?.content?.raw?.content?.[0]?.content?.[0]?.value,
                },
              }
            }),
          ],
        }
      } else {
        return {
          '@context': 'http://schema.org',
          '@type': 'FAQPage',
          mainEntity: [
            data.information?.map((q) => {
              return {
                '@type': 'Question',
                name: q.title,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: JSON.parse(q?.content?.raw ?? '{}')?.content?.[0]
                    ?.content?.[0]?.value,
                },
              }
            }),
          ],
        }
      }
  }
}
